import React from "react";
import { Responsive, Title, translate } from "react-admin";
import { compose } from "recompose";
import data from "../../license.json";

const styles = {
  flex: { display: "flex" },
  flexColumn: { display: "flex", flexDirection: "column" },
  leftCol: { flex: 1, marginRight: "1em" },
  rightCol: { flex: 1, marginLeft: "1em" },
  singleCol: { marginTop: "2em", marginBottom: "2em" },
};

const ossLicenseJsonArray = data;
const keys = Object.keys(ossLicenseJsonArray);

const LicenseEntry = ({ jsonKey }) => (
  <div key={jsonKey}>
    <p>
      <b>{jsonKey}</b>
    </p>
    <p>{ossLicenseJsonArray[jsonKey].licenses}</p>
    <p>{ossLicenseJsonArray[jsonKey].copyright}</p>
    <p>{ossLicenseJsonArray[jsonKey].licenseText}</p>
    <hr />
  </div>
);

const OssLicense = () => (
  <>
    <Title title={"other.oss"} />
    <Responsive
      xsmall={getLicenseEntries()}
      small={getLicenseEntries()}
      medium={
        <div style={styles.flex}>
          <div style={styles.leftCol}>{getLicenseEntries()}</div>
        </div>
      }
    />
  </>
);

const getLicenseEntries = () => (
  <div style={styles.flexColumn}>
    <div style={styles.singleCol}>
      {keys.map((key) => (
        <LicenseEntry jsonKey={key} />
      ))}
    </div>
  </div>
);

const enhance = compose(translate);
export default enhance(OssLicense);
